/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	(function(w, n){
	  w[n] = w[n] || function(){
	    (w[n].q = w[n].q || []).push(arguments);
	  }
	
	  w[n](function(t){
	    t = w[n];
	
	    w[n] = function(){
	      arguments[0] === 'send' && (w[n] = t) && t('set', '_no_slc', '1');
	
	      return t.apply(this, arguments);
	    }
	  });
	})(window, 'ga');
	
	(function(){
	  var host = (document.currentScript || {src: '//' + ("cnt.worldota.net") + '/'}).src.split('//')[1].split('/')[0];
	  var defaults = {
	    funnel_host:         host,
	    endpoint_host:       host,
	    endpoint_url_prefix: '/hc'
	  };
	  var config = window.HCFNL_LOADER_CONFIG;
	
	  for(var field in defaults){
	    if(!config[field]){
	      config[field] = defaults[field];
	    }
	  };
	
	  function cookie(name){
	    var value = '; ' + document.cookie,
	        parts = value.split('; ' + encodeURIComponent(name) + '=');
	
	    if(parts.length === 2){
	      return decodeURIComponent(parts.pop().split(';').shift());
	    }
	  }
	
	  function distribute(uid, segments){
	    var sequense = uid.substring(24, 30),
	        targets = [];
	
	    for(segment in segments){
	      for(var i = 0;i < segments[segment];i++){
	        targets.push(segment);
	      }
	    }
	
	    return targets[parseInt(sequense, 16) % targets.length];
	  }
	
	  (function(w, d, n, p){
	    var uid = cookie('uid') || p.buid;
	
	    if(uid){
	      d.cookie = 'uid=' + uid + '; path=/; max-age=31536000;' + (d.location.protocol === 'https:' ? ' secure; samesite=none' : '');
	    }
	
	    var b = p.segmentation && p.huid && distribute(p.huid, p.segmentation) || ("hc/static/master");
	    var s = ['/', p.funnel_host.replace('//', ''), b, 'funnel.js'].join('/');
	    var u = ['//', p.endpoint_host.replace('//', ''), p.endpoint_url_prefix].join('');
	
	    w.HcFunnelGlobal = w.HcFunnelGlobal || n;
	
	    w[n] = w[n] || function(){
	      (w[n].q || (w[n].q = [])).push(arguments);
	    };
	    w[n].t = w[n].t || Date.now();
	
	    w.hcfunnelurl = u;
	
	    var e = d.createElement('script');
	
	    e.onerror = function(){
	      var params = [
	        'category=tracking',
	        'action=funnel-loading',
	        'label=error'
	      ];
	
	      if(window.ota_http_request_id){
	        params.push('ota_http_request_id=' + window.ota_http_request_id);
	      }
	      if(uid){
	        params.push('domain_uid=' + encodeURIComponent(uid));
	      }
	
	      var url = u + '/event?' + params.join('&');
	
	      navigator.sendBeacon && navigator.sendBeacon(url);
	    }
	
	    e.src = s;
	    d.head.appendChild(e);
	  })(window, document, 'hcfunnel', config);
	})();


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// funnel-loader.js